import React, { createContext, useContext, useState, ReactNode } from "react";
import { ProfileType, PROFILE_SKILLS } from "../types";

type ProfileContextType = {
  profile: ProfileType;
  setProfile: (p: ProfileType) => void;
  isSkillRelevant: (skillName: string) => boolean;
  isExperienceRelevant: (skills?: string[]) => boolean;
};

const ProfileContext = createContext<ProfileContextType>({
  profile: "all",
  setProfile: () => {},
  isSkillRelevant: () => true,
  isExperienceRelevant: () => true,
});

export function ProfileProvider({ children }: { children: ReactNode }) {
  const [profile, setProfile] = useState<ProfileType>("all");

  const isSkillRelevant = (skillName: string): boolean => {
    if (profile === "all") return true;
    return PROFILE_SKILLS[profile].includes(skillName);
  };

  const isExperienceRelevant = (skills?: string[]): boolean => {
    if (profile === "all") return true;
    if (!skills || skills.length === 0) return true;
    const profileSkills = PROFILE_SKILLS[profile];
    return skills.some((s) => profileSkills.includes(s));
  };

  return (
    <ProfileContext.Provider
      value={{ profile, setProfile, isSkillRelevant, isExperienceRelevant }}
    >
      {children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => useContext(ProfileContext);
